const oktaConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  redirectUri: `${window.location.origin}/login/callback`,
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  disableHttpsCheck: false,
};

// Note: Group-based access control is handled at OKTA app level
// Only users assigned to the OKTA app (via groups) can authenticate

export default oktaConfig;
